import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Ca làm & bảng công (Mint-HR-Attendance). Tiền tố hra. Mã công, tên người / chi nhánh / ca là dữ liệu.
addMessages('vi', {
  'hra.title': 'Ca làm & bảng công',
  'hra.sub': 'Kỳ 10/2026 · cập nhật theo lượt chấm',
  'hra.locked': 'Đã chốt',
  'hra.back': 'Về Nhân sự',
  'hra.density': 'Mật độ',
  'hra.dStd': 'Chuẩn',
  'hra.dCompact': 'Gọn',
  'hra.notif': 'Thông báo · 4 mới',
  'hra.tNotif': '4 thông báo mới · mở ở Việc & Duyệt',
  'hra.more': 'Thêm thao tác',
  'hra.tSheet': 'Bảng công',
  'hra.tShift': 'Phân ca',
  'hra.tPts': 'Điểm chấm',
  'hra.tRule': 'Quy tắc công',
  'hra.pLock': 'Chốt bảng công',
  'hra.pLocked': 'Đã chốt 10/2026',
  'hra.pRota': 'Xoay ca theo mẫu',
  'hra.pPt': 'Điểm chấm',
  'hra.pSave': 'Lưu quy tắc',
  'hra.kStd': 'Công chuẩn 10/2026',
  'hra.kStdU': 'ngày · WorkCalendar',
  'hra.kNow': 'Có mặt hôm nay',
  'hra.kNowU': '22/Oct · 2 đi muộn',
  'hra.kWait': 'Chờ giải trình',
  'hra.kWaitU': 'thiếu lượt · đi muộn',
  'hra.kShift': 'Ca chưa phân',
  'hra.kShiftU': 'tuần {w}',
  'hra.search': 'Tìm nhân sự',
  'hra.searchPh': 'Tên, UserName, ghế…',
  'hra.brAria': 'Lọc theo chi nhánh',
  'hra.xnCount': '{n}/{m} đã xác nhận',
  'hra.xnSend': 'Gửi nhân viên xác nhận',
  'hra.sheetAria': 'Bảng công tháng 10/2026',
  'hra.sheetHd': 'Bảng công 10/2026',
  'hra.sheetNote': 'Tự tổng hợp · lượt chấm + đơn đã duyệt',
  'hra.sheetTip': 'Ca hành chính, T7 nửa ngày, ngày nghỉ, lễ: WorkCalendar (tblClientInfo)',
  'hra.sheetGrid': 'Bảng công theo ngày',
  'hra.cStaff': 'Nhân sự',
  'hra.cCong': 'Công',
  'hra.cCongTip': 'Ngày công tới hôm nay',
  'hra.cLate': 'Muộn',
  'hra.cLateTip': 'Số lần đi muộn',
  'hra.cMiss': 'Thiếu',
  'hra.cMissTip': 'Ngày thiếu lượt chấm',
  'hra.cLeave': 'Phép',
  'hra.cLeaveTip': 'Ngày phép',
  'hra.cXn': 'XN',
  'hra.cXnTip': 'Nhân viên xác nhận bảng công trên HANA Mee',
  'hra.xnDone': 'Đã XN',
  'hra.xnWait': 'Chờ XN',
  'hra.half': ' · T7 nửa ngày (WorkSatEnd)',
  'hra.noStaff': 'Không có nhân sự khớp bộ lọc.',
  'hra.lgOk': 'Đủ công',
  'hra.lgM': 'Đi muộn',
  'hra.lgMiss': 'Thiếu lượt chấm',
  'hra.lgP': 'Nghỉ phép',
  'hra.lgCT': 'Công tác',
  'hra.cellOk': 'Đủ công',
  'hra.cellM': 'Đi muộn',
  'hra.cellMiss': 'Thiếu lượt chấm · chờ giải trình',
  'hra.cellP': 'Nghỉ phép (đơn đã duyệt)',
  'hra.cellCT': 'Công tác (đơn đã duyệt)',
  'hra.cellOff': 'Ngày nghỉ theo lịch tuần',
  'hra.cellFut': 'Chưa tới',
  'hra.cdIn': 'Vào',
  'hra.cdOut': 'Ra',
  'hra.cdHow': 'Cách chấm',
  'hra.cdShift': 'Ca',
  'hra.cdShiftHalf': 'Hành chính · T7 nửa ngày (WorkCalendar)',
  'hra.cdShiftStd': 'Hành chính · theo WorkCalendar',
  'hra.cdReq': 'Đơn liên quan',
  'hra.cdNoExp': 'Chưa có giải trình',
  'hra.cdEditTo': 'Sửa thành',
  'hra.cdWhy': 'Lý do',
  'hra.cdWhyAria': 'Lý do sửa công',
  'hra.cdWhyPh': 'Máy chấm lỗi · đã đối chiếu camera',
  'hra.cdRemind': 'Nhắc giải trình',
  'hra.cdSave': 'Lưu công',
  'hra.cdEdit': 'Sửa công',
  'hra.edOk': 'Đủ công',
  'hra.edM': 'Đi muộn',
  'hra.edMiss': 'Thiếu lượt',
  'hra.edP': 'Phép',
  'hra.edCT': 'Công tác',
  'hra.close': 'Đóng',
  'hra.shiftAria': 'Lịch ca tuần',
  'hra.shiftHd': 'Lịch ca',
  'hra.shiftEmpty': '{n} ô chưa phân ca',
  'hra.shiftFull': 'Đã phân đủ ca',
  'hra.copyWk': 'Chép tuần trước',
  'hra.sendSh': 'Gửi lịch ca',
  'hra.shiftGrid': 'Lịch ca theo ngày',
  'hra.wkPrev': 'Tuần trước',
  'hra.wkNext': 'Tuần sau',
  'hra.wkLabel': 'Tuần {w} · {a}–{b}/Nov/2026',
  'hra.cover': 'Phủ ca · cần S 2 · C 2',
  'hra.coverShort': 'Thiếu người so với định mức ca (S 2 · C 2)',
  'hra.coverOk': 'Đủ định mức ca',
  'hra.shUnset': 'Chưa phân',
  'hra.shOff': 'Nghỉ',
  'hra.shCellAria': '{u} · {w} {d}/Nov · {k} · bấm để đổi ca',
  'hra.shUnsetAria': 'chưa phân ca',
  'hra.noShift': 'Chi nhánh này chỉ có ca hành chính (theo WorkCalendar).',
  'hra.tplHd': 'Mẫu ca',
  'hra.tplHint': 'Bấm một ô để đổi ca: Sáng → Chiều → Đêm → Hành chính → Nghỉ → trống. Mẫu xoay: 2 sáng · 2 chiều · nghỉ CN.',
  'hra.ptSection': 'Số cách chấm',
  'hra.ptN': '{n}/4 cách chấm',
  'hra.qrShow': 'Hiện mã',
  'hra.faceRemind': 'Nhắc đăng ký',
  'hra.ptNew': 'Điểm chấm',
  'hra.qrTitle': 'Mã QR · {p}',
  'hra.qrAria': 'Mã QR chấm công',
  'hra.qrImg': 'Mã QR minh hoạ',
  'hra.qrNote': 'Nhân viên mở HANA Mee › Chấm công › QR để quét. Mã đổi mỗi 30 giây, chỉ hợp lệ trong Wifi / GPS của điểm này.',
  'hra.qrPrint': 'In mã dự phòng (PDF)',
  'hra.pfTitle': 'Thêm điểm chấm',
  'hra.pfName': 'Tên điểm',
  'hra.pfNamePh': 'Kho Cát Lái',
  'hra.pfAddr': 'Địa chỉ',
  'hra.pfAddrPh': 'Số nhà, đường, quận',
  'hra.pfRadius': 'Bán kính GPS (m)',
  'hra.pfHow': 'Cách chấm',
  'hra.pfCancel': 'Huỷ',
  'hra.pfAdd': 'Thêm điểm chấm',
  'hra.ruleAria': 'Quy tắc công',
  'hra.r1': 'Giờ ca hành chính · ngày làm việc · lễ',
  'hra.r1s': 'Đọc từ WorkCalendar (tblClientInfo) · sửa ở Quản trị › Giờ làm việc & lễ',
  'hra.r1v': 'Theo WorkCalendar',
  'hra.r2': 'Đi muộn được miễn',
  'hra.r2s': 'Vào sau đầu ca không quá',
  'hra.r3': 'Về sớm được miễn',
  'hra.r3s': 'Ra trước cuối ca không quá',
  'hra.r4': 'Giải trình quên chấm',
  'hra.r4s': 'Tối đa mỗi người / tháng · quá thì cần TBP + HR',
  'hra.r5': 'Làm tròn giờ làm thêm',
  'hra.r5s': 'Theo block',
  'hra.r5a': '15 phút',
  'hra.r5b': '30 phút',
  'hra.r6': 'Chấm ngoài điểm chấm',
  'hra.r6s': 'GPS / Wifi không khớp điểm đã gán',
  'hra.r6a': 'Chặn',
  'hra.r6b': 'Cho chấm · TBP duyệt',
  'hra.r7': 'Chỉ tính làm thêm khi có đơn tăng ca đã duyệt',
  'hra.r7s': 'Giờ có mặt vượt ca mà không có đơn = không tính OT',
  'hra.r8': 'Chụp ảnh khi chấm bằng GPS',
  'hra.r8s': 'Chống chấm hộ · ảnh lưu 90 ngày',
  'hra.minutes': '{n} phút',
  'hra.times': '{n} lần',
  'hra.dec': 'Giảm',
  'hra.inc': 'Tăng',
  'hra.ncrHd': 'Không cần chấm công',
  'hra.ncrNote': 'NoClockRequired · vẫn tính đủ công theo WorkCalendar, không nhận thưởng chuyên cần.',
  'hra.ncrRm': 'Bỏ {u}',
  'hra.ncrAdd': '+ Thêm',
  'hra.mExp': 'Xuất bảng công (Excel)',
  'hra.mExpSub': 'Theo chi nhánh đang chọn · {n} người',
  'hra.mLoad': 'Nạp lượt chấm từ máy chấm',
  'hra.mLoadSub': 'Máy khuôn mặt cửa chính · Kho Bình Dương',
  'hra.mHr': 'Mở chấm công trong Nhân sự',
  'hra.mHrSub': 'Tab Chấm công · hôm nay',
  'hra.lockTitle': 'Chốt bảng công 10/2026?',
  'hra.lockText': 'Sau khi chốt, bảng công chuyển sang Bảng lương kỳ 10/2026. Còn {n} người chưa xác nhận và 5 ngày chờ giải trình. Mở khoá lại cần [HRD-MGR].',
  'hra.lockOk': 'Chốt',
  'hra.lockLater': 'Chưa',
  'hra.tLocked': 'Bảng công 10/2026 đã chốt · mở khoá cần [HRD-MGR]',
  'hra.tLockedDone': 'Đã chốt bảng công 10/2026 · chuyển sang Bảng lương',
  'hra.tExp': 'Đang xuất bảng công 10/2026 · {n} người',
  'hra.tLoad': 'Đã nạp 412 lượt chấm · 0 trùng',
  'hra.tSendXn': 'Đã gửi bảng công cho nhân viên xác nhận trên HANA Mee · hạn 25/Oct',
  'hra.tRemind': 'Đã nhắc {u} gửi giải trình công qua HANA Mee',
  'hra.tFixed': 'Đã sửa công {u} {d}/Oct · ghi nhật ký trước → sau',
  'hra.tRota': 'Đã xoay ca theo mẫu "2 sáng · 2 chiều · nghỉ CN" · {n} ô',
  'hra.tCopy': 'Đã chép lịch ca tuần trước sang tuần {w} · giữ ô đã sửa',
  'hra.tSendSh': 'Đã gửi lịch ca tuần {w} qua HANA Mee + Hei · {n} người',
  'hra.tToggle': '{a} {k} · {p}',
  'hra.tOn': 'Bật',
  'hra.tOff': 'Tắt',
  'hra.tFace': 'Đã nhắc {n} người đăng ký khuôn mặt trên HANA Mee',
  'hra.tPtNew': 'Đã thêm điểm chấm {n}',
  'hra.tQrPrint': 'Đang in mã QR tĩnh dự phòng · PDF vector',
  'hra.tRuleSaved': 'Đã lưu quy tắc công · áp từ kỳ 11/2026',
  'hra.tAdmin': 'Mở Quản trị › Giờ làm việc & lễ (tblClientInfo)',
  'hra.tNcrRm': 'Bỏ {u} khỏi danh sách không cần chấm',
  'hra.tNcrAdd': 'Chọn nhân sự không cần chấm · theo ghế BOD / tài xế thuê ngoài',
  'hra.emptyTitle': 'Chưa có lượt chấm công nào',
  'hra.emptyDesc': 'Khai điểm chấm (GPS · Wifi · QR · khuôn mặt) rồi mời nhân viên chấm trên HANA Mee.',
  'hra.errTitle': 'Không tải được bảng công',
  'hra.errDesc': 'Mất kết nối tới máy chủ lúc 08:42. Lượt chấm trên điện thoại vẫn được ghi tạm và đồng bộ lại sau.',
  'hra.retry': 'Thử lại',
  'hra.retrying': 'Đang tải lại…',
  'hra.npTitle': 'Cần quyền nhóm HR',
  'hra.npDesc': 'Màn bảng công toàn công ty dành cho ghế HR / quản lý. Dữ liệu của bạn xem ở HANA Mee.',
  'hra.npBtn': 'Mở HANA Mee',
});
